// Cliente del editor god-mode de la matriz de módulos. Pega a Orión /org/module-matrix*
// (los endpoints exigen thot_admin/superuser). Habilitado solo en la org ucognet.

const ORION = '/orion/api';

function authHeaders(): Record<string, string> {
  const token = localStorage.getItem('auth_token');
  return { Authorization: `Bearer ${token ?? ''}`, 'Content-Type': 'application/json' };
}

async function asJson<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const body = await res.text();
    throw new Error(`${res.status} ${res.statusText} — ${body.slice(0, 200)}`);
  }
  return res.json() as Promise<T>;
}

export interface ModuleMatrix {
  catalog: Record<string, string>;        // key → label
  always_on: string[];
  dev_only: string[];
  archetypes: Record<string, string[]>;   // archetype → [enabled keys]
}

export interface OrgModulesState {
  org_id: string;
  archetype: string | null;
  override: Record<string, boolean>;       // enabled_modules explícitos
  resolved: Record<string, boolean>;       // estado efectivo
}

export async function getMatrix(): Promise<ModuleMatrix> {
  return asJson<ModuleMatrix>(await fetch(`${ORION}/org/module-matrix`, { headers: authHeaders() }));
}

export async function setArchetypeModules(archetype: string, moduleKeys: string[]): Promise<void> {
  await asJson(await fetch(`${ORION}/org/module-matrix/archetype/${encodeURIComponent(archetype)}`, {
    method: 'PUT', headers: authHeaders(), body: JSON.stringify({ module_keys: moduleKeys }),
  }));
}

export async function getOrgModules(orgId: string): Promise<OrgModulesState> {
  return asJson<OrgModulesState>(
    await fetch(`${ORION}/org/module-matrix/org/${encodeURIComponent(orgId)}`, { headers: authHeaders() }),
  );
}

export async function setOrgModules(orgId: string, modules: Record<string, boolean>): Promise<void> {
  await asJson(await fetch(`${ORION}/org/module-matrix/org/${encodeURIComponent(orgId)}`, {
    method: 'PUT', headers: authHeaders(), body: JSON.stringify({ modules }),
  }));
}
